export default __webpack_public_path__ + "cc2982c4771969db5b3b36fbf95d3610.svg";